import { isNullable, isNumber, isString } from "../type-guards";
import { CommonSystemError } from "./system-error";
export class AscendErrorFactory {
    registry;
    constructor(registry) {
        this.registry = registry;
    }
    fromJSON(json) {
        if (!this.isValidJSON(json)) {
            return new CommonSystemError.Unexpected(`Unexpected error object: ${JSON.stringify(json)}`);
        }
        const Constructor = this.registry[json.errorCode];
        if (isNullable(Constructor)) {
            return new CommonSystemError.Unexpected(`Unexpected error object: ${JSON.stringify(json)}`);
        }
        return new Constructor(json.message, json.userMessage);
    }
    isValidJSON(v) {
        if (typeof v !== "object" || isNullable(v)) {
            return false;
        }
        const json = v;
        if (!["system", "client"].includes(json.type)) {
            return false;
        }
        if (!isString(json.errorCode) ||
            !isString(json.message) ||
            !isNumber(json.statusCode)) {
            return false;
        }
        return true;
    }
}
//# sourceMappingURL=ascend-error-factory.js.map